import { SignUp } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";

export default function SignUpPage() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: "100vh",
      background: "#0c0a09",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      fontFamily: "'Instrument Sans', sans-serif",
    }}>
      {/* Google Fonts */}
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Instrument+Sans:wght@400;500;600;700&display=swap');`}</style>

      {/* Logo */}
      <a href="/" onClick={() => navigate("/")}  style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", marginBottom: 16 }}>
        <div style={{ width: 36, height: 36, background: "#d97706", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color: "#0c0a09" }}>✦</div>
        <span style={{ fontFamily: "'Syne', sans-serif", fontSize: 22, fontWeight: 800, color: "#f5f0eb", letterSpacing: "-0.01em" }}>Limji</span>
      </a>

      {/* Pro benefits banner */}
      <div style={{
        background: "rgba(217,119,6,0.08)",
        border: "1px solid rgba(217,119,6,0.25)",
        borderRadius: 12,
        padding: "12px 20px",
        marginBottom: 24,
        display: "flex",
        alignItems: "center",
        gap: 10,
        maxWidth: 400,
        width: "100%",
      }}>
        <span style={{ fontSize: 18 }}>✦</span>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#d97706" }}>Free account — 3 generations/day</div>
          <div style={{ fontSize: 11, color: "#a39585", marginTop: 2 }}>Upgrade to Pro anytime for $19/month · 150 generations/day</div>
        </div>
      </div>

      {/* Clerk Sign Up Component */}
      <SignUp
        routing="path"
        path="/sign-up"
        afterSignUpUrl="/app"
        signInUrl="/sign-in"
        appearance={{
          variables: {
            colorPrimary: "#d97706",
            colorBackground: "#1a1714",
            colorInputBackground: "#211e1b",
            colorInputText: "#f5f0eb",
            colorText: "#f5f0eb",
            colorTextSecondary: "#a39585",
            colorNeutral: "#2e2a26",
            borderRadius: "10px",
            fontFamily: "'Instrument Sans', sans-serif",
          },
          elements: {
            card: {
              background: "#1a1714",
              border: "1px solid #2e2a26",
              borderRadius: "16px",
              boxShadow: "0 24px 64px rgba(0,0,0,0.4)",
            },
            headerTitle: {
              fontFamily: "'Syne', sans-serif",
              fontWeight: 800,
              color: "#f5f0eb",
            },
            headerSubtitle: { color: "#a39585" },
            formButtonPrimary: {
              background: "#d97706",
              color: "#0c0a09",
              fontWeight: 700,
              fontFamily: "'Instrument Sans', sans-serif",
            },
            footerActionLink: { color: "#d97706" },
            formFieldLabel: { color: "#a39585" },
            dividerLine: { background: "#2e2a26" },
            dividerText: { color: "#6b5f52" },
            socialButtonsBlockButton: {
              border: "1px solid #2e2a26",
              background: "#211e1b",
              color: "#f5f0eb",
            },
          },
        }}
      />

      {/* Back link */}
      <a href="/" onClick={() => navigate("/")}  style={{ marginTop: 24, fontSize: 13, color: "#6b5f52", textDecoration: "none" }}>
        ← Back to home
      </a>
    </div>
  );
}
